import { API_URL, GOCARDLESS_SERVICE_PATH } from '@/constants/apiUrl'
import { forceReplace } from './forceRedirect'

// The user's way out of open banking before the bank (only when `get-context` says `isCancellable`):
// the backend fails the GoCardless session as cancelled and sends the browser on to onboarding, which
// rewinds the journey to the step before open banking. A full navigation like `redirect-back`, but
// replacing the GoCardless entry: the session is dead afterwards (its cookie is expired, so the
// screens would only get 401s), so Back from the questionnaire must skip it.
export const cancelGocardless = (): void => {
  forceReplace(`${API_URL}/${GOCARDLESS_SERVICE_PATH}/cancel`)
}
